import { type FeedbackContext } from '../../constants/analytics';

export const getFeedbackCollectorContext = (keys: FeedbackContext): string => {
	return JSON.stringify(keys);
};
